import React, { useEffect, useState } from "react"
import styles from "./index.module.css"
import DataTable from "ui/DataTable"
import { FilePdfOutlined, EllipsisOutlined } from "@ant-design/icons"
import { Button, Dropdown, Menu, Spin } from "antd"
import { useParams, useNavigate } from "react-router-dom"
import { getBookingWaivers, notifyWaiver } from "store/digital-waiver"
import { useDispatch, useSelector } from "react-redux"
import NotifyGuestModal from "./modal/NotifyGuestModal"
import { DownloadDocumentModal } from "./modal/DownloadDocument"
import { toaster } from "components/common/Toast"
import { WaiverDetails } from "../WaiverDetails"
import { set } from "store"
export const GuestWaiverDetails = () => {
  const { id } = useParams()
  console.log(id, "bookingId") // Log the booking ID to verify it's being captured correctly
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { loading: notifyLoading } = useSelector((store) => store?.digitalWaiver.notifyWaiver) || {}
  const { items, loading } = useSelector((store) => store?.digitalWaiver?.bookingWaivers) || {}
  const [sortParams, setSortParams] = useState({})
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isDownloadModalVisible, setIsDownloadModalVisible] = useState(false)
  const [isShowGuestDetails, setIsShowGuestDetails] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [recordData, setRecordData] = useState({})
  console.log(recordData, "recordData")
  const columns = [
    {
      title: "Full Name",
      dataIndex: "full_name",
      key: "full_name",
      render: (text) => text || "-"
    },
    {
      title: "Guest Email",
      dataIndex: "guest_email",
      key: "guest_email",
      render: (text) => {
        if (!text) return "-"
        const display = text.length > 10 ? text.substring(0, 10) + "..." : text
        return <span title={text}>{display}</span>
      }
    },
    {
      title: "Phone Number",
      dataIndex: "phone_number",
      key: "phone_number",
      render: (text) => {
        if (!text) return "-"
        const display = text.length > 8 ? text.substring(0, 10) + "..." : text
        return <span title={text}>{display}</span>
      }
    },
    {
      title: "Document",
      dataIndex: "signed_documents",
      key: "signed_documents",
      sorter: true,
      sortOrder: sortParams.document === "asc" ? "ascend" : sortParams.document === "desc" ? "descend" : null,
      render: (signedDocuments, record) => {
        // Check if this is an unsigned record (status === "Unsigned")
        if (record.status === "Unsigned") {
          const docName = record.documents?.[0] || `Document 1.pdf`
          const displayName = record.documents.length > 1 ? `${docName} +${record.documents.length - 1}` : docName
          return (
            <button
              className="mb-xxs"
              onClick={() => {
                setRecordData(record)
                setIsShowGuestDetails(true)
                setIsLoading(true)
              }}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                margin: 0,
                cursor: "pointer",
                textAlign: "left",
                font: "inherit",
                color: "inherit"
              }}
            >
              <FilePdfOutlined className={styles.pdfIcon} />
              {displayName}
            </button>
          )
        }
        // Handle signed documents
        if (signedDocuments && signedDocuments.length > 0) {
          const docName = record.documents?.[0] || `Document 1.pdf`
          const displayName = signedDocuments.length > 1 ? `${docName} +${signedDocuments.length - 1}` : docName
          return (
            <button
              className="mb-xxs"
              onClick={() => {
                setRecordData(record)
                setIsShowGuestDetails(true)
                setIsLoading(true)
              }}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                margin: 0,
                cursor: "pointer",
                textAlign: "left",
                font: "inherit",
                color: "inherit"
              }}
            >
              <FilePdfOutlined className={styles.pdfIcon} />
              {displayName}
            </button>
          )
        }
        return "-"
      }
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
      render: (text) => text || "-"
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: true,
      sortOrder: sortParams.status === "asc" ? "ascend" : sortParams.status === "desc" ? "descend" : null,
      render: (status) => {
        const statusClass = status === "Signed" ? styles.statusSigned : styles.statusUnsigned
        return <span className={statusClass}>{status || "Unsigned"}</span>
      }
    },
    {
      title: "Action",
      key: "action",
      render: (record) => {
        const isUnsigned = record.status !== "Signed"

        const menuItems = []

        if (isUnsigned) {
          menuItems.push(
            <Menu.Item
              key="notify"
              onClick={() => {
                setRecordData(record)
                setIsModalVisible(true)
              }}
            >
              Notify Guest
            </Menu.Item>
          )
        } else {
          menuItems.push(
            <Menu.Item
              key="download"
              onClick={() => {
                setIsDownloadModalVisible(true)
                setRecordData(record)
              }}
            >
              Download
            </Menu.Item>
          )
        }

        return (
          <Dropdown overlay={<Menu>{menuItems}</Menu>} trigger={["click"]}>
            <Button type="text" icon={<EllipsisOutlined className={styles.icon} />} className={styles.actionCell} />
          </Dropdown>
        )
      }
    }
  ]
  useEffect(() => {
    if (id) {
      dispatch(getBookingWaivers(id, sortParams))
    }
  }, [id, dispatch, sortParams])

  // Transform the API data to match the table structure
  const tableData =
    items?.map((item, index) => ({
      key: item.id || `waiver-${index}`,
      ...item
    })) || []

  const signedCount = items?.filter((item) => item.status === "Signed").length || 0
  const totalCount = items?.length || 0

  // Handle sorting changes
  const handleTableChange = (pagination, filters, sorter) => {
    const newSortParams = { ...sortParams }

    // Clear previous sort for this field if it exists
    delete newSortParams.document
    delete newSortParams.status

    // Add new sort if there's an active sorter
    if (sorter && sorter.field) {
      const sortOrder = sorter.order === "ascend" ? "asc" : sorter.order === "descend" ? "desc" : null
      if (sortOrder) {
        newSortParams[sorter.field] = sortOrder
      }
    }

    setSortParams(newSortParams)
  }

  const handleNotifyGuest = () => {
    const payload = {
      shared_waiver_id: recordData?.shared_waiver_id
    }
    const guestPayload = {
      notify_by: "email"
    }
    dispatch(notifyWaiver(id, recordData?.shared_waiver_id ? payload : guestPayload)).then((res) => {
      toaster.success(res.message)
      setIsModalVisible(false)
      dispatch(getBookingWaivers(id))
    })
  }

  return (
    <div className={styles.waiverDetailsContainer}>
      <div className={styles.waiverTableTitle}>
        Guest Waiver Details ({signedCount} out of {totalCount} Signed)
      </div>
      <DataTable columns={columns} dataSource={tableData} pagination={false} rowKey="key" loading={loading} onChange={handleTableChange} />
      <NotifyGuestModal
        loading={notifyLoading}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onConfirm={handleNotifyGuest}
      />
      <DownloadDocumentModal open={isDownloadModalVisible} onCancel={() => setIsDownloadModalVisible(false)} recordData={recordData} />
      {isShowGuestDetails && (
        <WaiverDetails
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          recordData={recordData}
          visible={isShowGuestDetails}
          onCancel={() => setIsShowGuestDetails(false)}
        />
      )}
    </div>
  )
}
